/**
 * Tiny first-party cookie helpers shared across the client. Centralised here
 * so the app-shell chrome (theme, consent, anon id) and the page-level forms
 * (newsletter, contact, onboarding) read and write cookies through one
 * implementation instead of duplicating the parsing/serialisation logic.
 *
 * All helpers are SSR-safe: they no-op / return null when `document` is not
 * available so they can be called unconditionally from component bodies.
 */

export function setCookie(name: string, value: string, days: number) {
  if (typeof document === 'undefined') return
  const maxAge = days * 24 * 60 * 60
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${name}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null
  return (
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1] ?? null
  )
}
